module.exports = __webpack_public_path__ + "assets/SBSansUI-Bold.17e89baf98bf552e2ab851c8a35da94336c485a3b7b9f0c2a77e6910c1e267c1.ttf";